<template>
    <div class="price-wrapper mb-2">
        <!--
        <div v-if="offer.commission && offer.commission.percentage >= 10" class="badge badge-primary mr-1 mb-1">
            Stay Reward 5%
        </div>
        -->
        <div v-if="offer.rateCode == 'PRO' || offer.rateCode == 'SPC'" class="badge badge-success">
            Special Deal
        </div>
        <div><small>{{ dateDifference(offer.checkInDate, offer.checkOutDate) }} {{ $tc('night', dateDifference(offer.checkInDate, offer.checkOutDate)) }}, {{ offer.guests.adults }} {{ $tc('adult', offer.guests.adults) }}</small></div>
        <div class="display-4" v-if="offer.roomQuantity > 1">
            <template v-if="offer.price.total">
                {{ currency(offer.price.currency) }}{{ formatPrice(offer.price.total * offer.roomQuantity) }}
            </template>
            <template v-else>
                {{ currency(offer.price.currency) }}{{ formatPrice(offer.price.base * offer.roomQuantity) }}
            </template>
        </div>
        <div class="display-4" v-else>
            <template v-if="offer.price.total">
                {{ currency(offer.price.currency) }}{{ formatPrice(offer.price.total) }}
            </template>
            <template v-else>
                {{ currency(offer.price.currency) }}{{ formatPrice(offer.price.base) }}
            </template>
        </div>
        <div>
            <template v-if="offer.price.total">
                <small>Includes taxes and fees</small>
            </template>
            <template v-else>
                <small><strong>Excluding taxes and fees</strong></small>
            </template>
        </div>
    </div>
</template>

<script>
    import dayjs from 'dayjs'

    export default {
        name: 'Price',
        props: {
            offer: {
                type: Object,
                required: true
            }
        },
        methods: {
            formatPrice(value) {
                let val = (value/1).toFixed(2).replace('.', ',')
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            },
            dateDifference(date1, date2) {
                var a = dayjs(date2, "YYYY-MM-DD");
                var b = dayjs(date1, "YYYY-MM-DD");
                return a.diff(b, 'days');
            },
            currency(iso) {
                if (iso == 'EUR') {
                    return '€';
                }
            },
        },
        i18n: { // `i18n` option, setup locale info for component
            messages: {
                en: {
                    night: 'night | nights',
                    adult: 'adult | adults'
                }
            },
        }
    }
</script>

<style scoped>

</style>